import { MODULE_FALLBACKS } from '../utils/constants'
import { getInstrumentTimeWindowString, formatTimeOfDay } from '../utils/studyTimelineTimeWindow'

export const TRIGGER_KIND = {
  visit: 'visit',
  instrument: 'instrument',
  calendar: 'calendar',
  participant: 'participant',
  persistent: 'persistent',
  other: 'other',
}

export const OCCURRENCE_SOURCE = {
  legacy: 'legacy',
  engine: 'engine',
}

/**
 * @typedef {object} ProjectedOccurrence
 * @property {string} instrumentId
 * @property {string} scheduleId
 * @property {number} scheduleIndex
 * @property {number} occurrenceIndex
 * @property {number} studyDay
 * @property {number|null} studyDayEnd
 * @property {'legacy'|'engine'} source
 * @property {string} triggerKind
 * @property {object} instrumentData
 */

export const createProjectedOccurrence = ({
  instrument,
  schedule,
  scheduleIndex,
  scheduleId,
  occurrenceIndex,
  studyDay,
  studyDayEnd = null,
  source = OCCURRENCE_SOURCE.legacy,
  triggerKind = TRIGGER_KIND.other,
}) => ({
  instrumentId: String(instrument.id),
  scheduleId: scheduleId || '',
  scheduleIndex,
  scheduleVersion: schedule?.version ?? null,
  occurrenceIndex,
  studyDay,
  studyDayEnd,
  windowStart: null,
  windowEnd: null,
  source,
  triggerKind,
  instrumentData: instrument,
  schedule,
})

export const projectedOccurrenceToScheduledItem = (occ, context = {}) => {
  const { useAbsoluteStartDate, absoluteStartDate } = context
  const instrument = occ.instrumentData
  const schedule = occ.schedule
  const timeWindow =
    getInstrumentTimeWindowString(schedule, instrument, {
      useAbsoluteStartDate,
      absoluteStartDate,
    }) || formatTimeOfDay(schedule?.deploy?.time_of_day)

  return {
    id: `instrument-${occ.instrumentId}-sched-${occ.scheduleIndex}-occ-${occ.occurrenceIndex}`,
    studyDay: occ.studyDay,
    studyDayEnd: occ.studyDayEnd ?? null,
    label:
      instrument?.metadata?.display_name ||
      instrument?.title ||
      instrument?.name ||
      MODULE_FALLBACKS.INSTRUMENT_LABEL,
    type: 'instrument',
    window: timeWindow,
    instrumentId: instrument?.id,
    instrumentData: instrument,
    scheduleIndex: occ.scheduleIndex,
    scheduleId: occ.scheduleId,
    triggerKind: occ.triggerKind,
    source: occ.source,
    occurrenceIndex: occ.occurrenceIndex,
  }
}

export const mapOccurrencesToScheduledItems = (occurrences, context = {}) =>
  occurrences.map(occ => projectedOccurrenceToScheduledItem(occ, context))
